// extracted by mini-css-extract-plugin
module.exports = {"tips":"index_tips_xhKMX","tips-warning":"index_tips-warning_1Sp6b","tips-text":"index_tips-text_3mmSw","form":"index_form_3QNBE","had-tips":"index_had-tips_1aI8J"};